@use '@design/design-tokens/typography/typography' as *;

.exchangeCardRoot {
  display: flex;
  gap: 8px;
  align-items: center;
}

.details {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.title {
  @include typography-v2-body-xs;

  color: var(--text-default);
  text-transform: uppercase;
}

.subtitle {
  @include typography-v2-body-xs;

  color: var(--text-soft);
}

.country {
  display: flex;
  align-items: center;
}
